var THREE         = require("three");
var GUIHandleView  = require("./guiHandleView.js");
var lib_core      = require("lib-core");

var GlobalRotationHandleView = function (model, editorView, handleId, config) {
    GUIHandleView.call(this, model, editorView, handleId, config);
    var self = this;

    this.material = new THREE.MeshBasicMaterial( {
        color: this.config.color,
        side: THREE.DoubleSide,
        transparent: (this.config.opactiy == 1)?false: true,
        opacity: this.config.opacity
    } );

    this.model.snapped.onChange(this, function(val){
        self.snapChanged(val);
    });

    this.model.hovered.onChange(this, function(val){
        self.snapChanged(false);
    });
}

lib_core.inherit(GlobalRotationHandleView, GUIHandleView);

GlobalRotationHandleView.prototype.repositionMesh = function(mesh, position){
    console.error("not implimented");
}

GlobalRotationHandleView.prototype.buildMesh = function(radius){
    console.error("not implimented");
}


GlobalRotationHandleView.prototype.buildSegGeometry = function(radius){
    var handleSize = this.config.size * (radius/10);
    var handleSpacing = this.extraRadius * (radius/10);
    var shape = new THREE.RingGeometry(
        radius + handleSpacing,
        radius + handleSpacing + handleSize,
        8, 0, -0.2, 0.4);
    return shape;
}

GlobalRotationHandleView.prototype.buildRingGeometry = function(radius){
    var handleSize = this.config.size * (radius/10);
    var handleSpacing = this.extraRadius * (radius/10);
    var shape = new THREE.RingGeometry(
        radius + handleSpacing,
        radius + handleSpacing + handleSize,
        32);
    return shape;
}

GlobalRotationHandleView.prototype.snapChanged = function(value){
    if(value){
        this.handleMesh.children[0].material.transparent = false;
    } else {
        this.handleMesh.children[0].material.transparent = true;
    }
}

module.exports = GlobalRotationHandleView;

